import { beginTask, endTask } from 'redux-nprogress';
import { redirect } from 'redux-first-router';
// import { selectQuery } from '../../../../store/reducers/location.selectors';
import { ACCOUNT_INFORMATION_VIEW } from '../../AccountInfo/module/accountInfo';
import viewNames from '../../../../store/actions/view.types';
import routes from '../../../routes.global';

export const STORE_KEY = 'RequestNewPassword2';
export const selectRequestNewPasswordState = state => state[STORE_KEY];

// ------------------------------------
// Reducer
// ------------------------------------
const actions = {};
const initialState = {
  error: null,
  email: null,
  submissionSuccess: null,
};

const requestPassword2Reducer = (state = initialState, action) => {
  const handler = actions[action.type];
  return handler ? handler(state, action) : state;
};

export default requestPassword2Reducer;

// ------------------------------------
// Actions
// ------------------------------------
export const SUBMIT_PASSWORD2_REQUEST = `${STORE_KEY}/SUBMIT_PASSWORD2_REQUEST`;
export const SUBMIT_PASSWORD2_SUCCESS = `${STORE_KEY}/SUBMIT_PASSWORD2_SUCCESS`;
export const SUBMIT_PASSWORD2_ERROR = `${STORE_KEY}/SUBMIT_PASSWORD2_ERROR`;
export const RESET_VIEW = `${STORE_KEY}/RESET_VIEW`;

export const resetView = () => ({
  type: RESET_VIEW,
});

export const submitPasswordError = error => ({
  type: SUBMIT_PASSWORD2_ERROR,
  payload: { error },
});

export const submitPasswordSuccess = () => ({
  type: SUBMIT_PASSWORD2_SUCCESS,
});

export const submitPasswordRequest = email => ({
  type: SUBMIT_PASSWORD2_REQUEST,
  payload: { email },
});

actions[RESET_VIEW] = state => ({ ...state,
  ...initialState,
});

actions[SUBMIT_PASSWORD2_REQUEST] = (state, { payload }) => ({ ...state,
  email: payload.email,
  error: null,
  submissionSuccess: null,
});

actions[SUBMIT_PASSWORD2_ERROR] = (state, { payload }) => ({ ...state,
  error: payload.error,
  submissionSuccess: false,
});

actions[SUBMIT_PASSWORD2_SUCCESS] = state => ({ ...state,
  error: null,
  submissionSuccess: true,
});


// ------------------------------------
// Submit email for Password Reset
// ------------------------------------
export const handleSubmitPasswordRequest = email => async (dispatch, getState, { api }) => {
  try {
    dispatch(beginTask());
    dispatch(submitPasswordRequest(email));
    await api.user.submitDecryptResetRequest({ email });
    dispatch(submitPasswordSuccess());
  } catch (error) {
    console.log('Error from call to api.user.getUserInfo:\n %O', error);
    dispatch(submitPasswordError(error));
  } finally {
    dispatch(endTask());
  }
};

// ------------------------------------
// View / Route
// ------------------------------------
export const REQUEST_PASSWORD2_VIEW = `${STORE_KEY}/REQUEST_PASSWORD2_VIEW`;
viewNames[REQUEST_PASSWORD2_VIEW] = 'RequestPassword2';
routes[REQUEST_PASSWORD2_VIEW] = {
  path: '/must-reset-password',
  thunk: async (dispatch, getState) => {
    const { loggedIn } = getState().auth;
    // if (loggedIn) {
    //   await dispatch(redirect({ type: ACCOUNT_INFORMATION_VIEW }));
    // }
  },
};



// WEBPACK FOOTER //
// ./src/app/views/PasswordForceRequest/module/requestPassword2.js